"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_69_10_3 = void 0;
/**
 * Migrate to 69.10.3
 *
 * delete MaxLengthVerpackungVirtual on config
 *
 */
function migration_69_10_3(json) {
    if (json) {
        delete json.MaxLengthVerpackungVirtual;
    }
    return json;
}
exports.migration_69_10_3 = migration_69_10_3;
//# sourceMappingURL=migration_69_10_3.js.map